export default __webpack_public_path__ + "static/media/swissLogo.f1d6bd89.png";